module.exports = __webpack_public_path__ + "img/739-b2c7ee.png";